'use client';

import { FC } from 'react';
import { Pill } from '@/_components';
import type { IdentityVerificationPillProps } from './IdentityVerificationPill.types';
import type { PillIntent } from '@/_components/Pill/Pill.types';
import type { IconType } from '@/_types/icons';
import type { IdentityVerificationStatus } from '@/_types/models/taxReturns';

const STATUS_MAP: Record<
  IdentityVerificationStatus,
  { intent: PillIntent; text: string; icon: IconType }
> = {
  not_started: { intent: 'default', text: 'Not Started', icon: 'circle' },
  requires_input: { intent: 'warning', text: 'Needs Info', icon: 'warning' },
  processing: { intent: 'info', text: 'Processing', icon: 'refresh' },
  verified: { intent: 'success', text: 'Verified', icon: 'check-circle' },
  canceled: { intent: 'default', text: 'Cancelled', icon: 'x-circle' },
  failed: { intent: 'danger', text: 'Failed', icon: 'x-circle' },
};

export const IdentityVerificationPill: FC<IdentityVerificationPillProps> = ({
  status,
  error_code,
}) => {
  if (error_code) {
    return (
      <Pill
        label="Failed"
        intent="danger"
        isRound={true}
        size="normal"
        iconLeft="x-circle"
      />
    );
  }

  const effectiveStatus = status || 'not_started';
  const { text, intent, icon } = STATUS_MAP[effectiveStatus];

  return (
    <Pill
      label={text}
      intent={intent}
      isRound={true}
      size="normal"
      iconLeft={icon}
    />
  );
};
